import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './shared/auth/guards/auth.guard';
import { PagesComponent } from './pages/pages.component';

const routes: Routes = [
  { path: '',
    component: PagesComponent, loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule) },
  { path: 'login', loadChildren: () => import('./shared/login-template/login-template.module').then((m) => m.LoginTemplateModule ) },
  { path: 'register', loadChildren: () => import('./shared/login-template/login-template.module').then((m) => m.LoginTemplateModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true } )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
